import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import Header from "./components/Header/Header";
import HeroSection from "./components/HeroSection/HeroSection";
import DynamicPrice from "./components/SponsorDashboard/DynamicPrice"; // rename as SponsorDashboard
import ClubDashboard from "./components/ClubDashboard/ClubDashboard";
import Footer from "./components/Footer/Footer";
import FloatingChatbot from "./components/Chatbot/FloatingChatbot";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import TokenForm from "./components/TokenForm/TokenForm";
import ClubsList from "./pages/ClubsList";
import CmsPage from "./pages/CmsPage";
import ClubDetailPage from "./pages/ClubDetailPage";
import SponsorListPage from "./pages/SponsorListPage";
import DonationConfirmation from "./components/RegisterForm/DonationConfirmation";
import MetaTags from "./components/MetaTags/MetaTags";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import SponsorDonationOverview from "./pages/SponsorDonationOverview";
import MarketPage from "./pages/MarketPage";
import SponsoringPage from "./pages/SponsoringPage";
// ✅ NEW: Toastify imports
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DonationProvider } from "./context/DonationContext"; // adjust path as needed
import AdminRoutes from "./components/AdminLayout/adminRoutes";

const SponsorDashboard = DynamicPrice; // Alias to improve clarity
const AppContent = () => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const renderDashboard = () => {
    if (isAuthenticated) {
      if (user?.role === "admin") return <SponsorDashboard />;
      if (user?.role === "club") return <ClubDashboard />;
      if (user?.role === "sponsor") return <SponsorDashboard />;
    }
    return <SponsorDashboard />;
  };

  // ✅ Logic to show TokenForm only for non-logged-in usersor sponsor
  const showTokenForm = !isAuthenticated || user?.role === "sponsor";

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {user?.role === "admin" && (
          <div className="bg-gray-900 text-white text-sm text-center py-2 px-3">
            Du bist als Admin angemeldet.{" "}
            <Link to="/admin/clubs" className="underline font-semibold">
              Zum Admin-Bereich
            </Link>
          </div>
        )}
        {user?.role !== "admin" && <Header />}
        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <HeroSection />
                  {renderDashboard()}
                  {showTokenForm && <TokenForm />}
                </>
              }
            />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/tokenform"
              element={showTokenForm ? <TokenForm /> : <Navigate to="/" />}
            />
            <Route path="/clubs" element={<ClubsList />} />
            <Route path="/cms/:slug" element={<CmsPage />} />
            <Route path="/:clubname" element={<ClubDetailPage />} />
            <Route path="/sponsors" element={<SponsorListPage />} />
            <Route path="/sponsor/donations" element={<SponsorDonationOverview />} />
            <Route path="/donation-confirmation" element={<DonationConfirmation />} />
            <Route path="*" element={<div style={{ padding: 20 }}>Fallback Reached</div>} />
            <Route path="/admin/*" element={<AdminRoutes />} />
            <Route path="/teamcoin-markt" element={<MarketPage />} />
            <Route path="/sponsoring" element={<SponsoringPage />} />
          </Routes>
        </main>
        <Footer />
        <ToastContainer position="top-right" autoClose={3000} />
        <FloatingChatbot />

      </div>
    </Router>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <LanguageProvider>
        <DonationProvider>
          <PayPalScriptProvider
            options={{
              "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
              currency: "EUR",
            }}
          >
            <MetaTags />
            <AppContent />
          </PayPalScriptProvider>
        </DonationProvider>
      </LanguageProvider>
    </AuthProvider>
  );
};

export default App;
